{
  "HELP_CENTER": {
    "TITLE": "Hjælpecenter",
    "NEW_PAGE": {
      "DESCRIPTION": "Opret selvbetjente hjælpecenterportaler til dine kunder. Hjælp dem med at finde svar hurtigt, uden at vente. Strømlin henvendelser, øg effektiviteten hos dine agenter, og løft kundesupporten.",
      "CREATE_PORTAL_BUTTON": "Opret portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Uden titel"
    },
    "HEADER": {
      "FILTER": "Filtrer efter",
      "SORT": "Sorter efter",
      "LOCALE": "Landestandard",
      "SETTINGS_BUTTON": "Indstillinger",
      "NEW_BUTTON": "Ny artikel",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publiceret",
        "DRAFT": "Draft",
        "ARCHIVED": "Arkiveret"
      },
      "TITLES": {
        "ALL_ARTICLES": "Alle artikler",
        "MINE": "Mine artikler",
        "DRAFT": "Draft-artikler",
        "ARCHIVED": "Arkiverede artikler"
      },
      "LOCALE_SELECT": {
        "TITLE": "Vælg sprog",
        "PLACEHOLDER": "Vælg sprog",
        "NO_RESULT": "Ingen sprog fundet",
        "SEARCH_PLACEHOLDER": "Søg efter sprog"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Alle artikler",
      "PUBLISH_BUTTON": "Udgiv",
      "MOVE_TO_ARCHIVE_BUTTON": "Flyt til arkiv",
      "PREVIEW": "Eksempelvisning",
      "ADD_TRANSLATION": "Tilføj oversættelse",
      "OPEN_SIDEBAR": "Åbn sidepanel",
      "CLOSE_SIDEBAR": "Luk sidepanel",
      "SAVING": "Gemmer...",
      "SAVED": "Gemt"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Upload billede",
        "UPLOADING": "Uploader...",
        "SUCCESS": "Billede blev uploadet",
        "ERROR": "Fejl under overførsel af billede",
        "UN_AUTHORIZED_ERROR": "Du har ikke tilladelse til at overføre billeder",
        "ERROR_FILE_SIZE": "Billedets størrelse skal være mindre end {size}MB",
        "ERROR_FILE_FORMAT": "Billedformatet skal være jpg, jpeg eller png",
        "ERROR_FILE_DIMENSIONS": "Billeddimensioner skal være mindre end 2000 x 2000 px"
      },
      "ANCHOR": {
        "BUTTON": "Indsæt anker",
        "TITLE": "Indsæt anker",
        "SUBMIT": "Indsæt",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikelindstillinger",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategori",
          "TITLE": "Vælg kategori",
          "PLACEHOLDER": "Vælg kategori",
          "NO_RESULT": "Ingen kategori fundet",
          "SEARCH_PLACEHOLDER": "Søg kategori"
        },
        "AUTHOR": {
          "LABEL": "Forfatter",
          "TITLE": "Vælg forfatter",
          "PLACEHOLDER": "Vælg forfatter",
          "NO_RESULT": "Ingen forfattere fundet",
          "SEARCH_PLACEHOLDER": "Søg efter forfatter"
        },
        "META_TITLE": {
          "LABEL": "Metatitel",
          "PLACEHOLDER": "Tilføj en metatitel"
        },
        "META_DESCRIPTION": {
          "LABEL": "Metabeskrivelse",
          "PLACEHOLDER": "Tilføj din metabeskrivelse for bedre SEO-resultater..."
        },
        "META_TAGS": {
          "LABEL": "Metatags",
          "PLACEHOLDER": "Tilføj meta-tags adskilt af komma..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arkivér artikel",
        "DELETE": "Slet artikel"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Ikke kategoriseret",
      "SEARCH_RESULTS": "Søgeresultater for {query}",
      "EMPTY_TEXT": "Søg efter artikler, der skal indsættes i svar.",
      "SEARCH_LOADER": "Søger...",
      "INSERT_ARTICLE": "Indsæt",
      "NO_RESULT": "Ingen artikler fundet",
      "COPY_LINK": "Kopiér artikellink til udklipsholder",
      "OPEN_LINK": "Åbn artikel i ny fane",
      "PREVIEW_LINK": "Forhåndsvis artikel"
    },
    "PORTAL": {
      "HEADER": "Portaler",
      "DEFAULT": "Standard",
      "NEW_BUTTON": "Ny portal",
      "ACTIVE_BADGE": "aktiv",
      "CHOOSE_LOCALE_LABEL": "Vælg en landestandard",
      "LOADING_MESSAGE": "Indlæser portaler...",
      "ARTICLES_LABEL": "artikler",
      "NO_PORTALS_MESSAGE": "Der er ingen tilgængelige portaler",
      "ADD_NEW_LOCALE": "Tilføj en ny landestandard",
      "POPOVER": {
        "TITLE": "Portaler",
        "PORTAL_SETTINGS": "Portalindstillinger",
        "SUBTITLE": "Du har flere portaler og kan have forskellige landestandarder for hver portal.",
        "CANCEL_BUTTON_LABEL": "Annuller",
        "CHOOSE_LOCALE_BUTTON": "Vælg landestandard"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artikler",
            "ADD": "Tilføj landestandard",
            "VISIT": "Besøg websted",
            "SETTINGS": "Indstillinger",
            "DELETE": "Slet"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalkonfigurationer",
            "ITEMS": {
              "NAME": "Navn",
              "DOMAIN": "Tilpasset domæne",
              "SLUG": "Slug",
              "TITLE": "Portaltitel",
              "THEME": "Temafarve",
              "SUB_TEXT": "Portalundertekst"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Tilgængelige landestandarder",
            "TABLE": {
              "NAME": "Landestandardnavn",
              "CODE": "Landestandardkode",
              "ARTICLE_COUNT": "Antal artikler",
              "CATEGORIES": "Antal kategorier",
              "SWAP": "Byt",
              "DELETE": "Slet",
              "DEFAULT_LOCALE": "Standard"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Slet portal",
          "MESSAGE": "Er du sikker på, at du vil slette denne portal",
          "YES": "Ja, slet portal",
          "NO": "Nej, behold portal",
          "API": {
            "DELETE_SUCCESS": "Portalen blev slettet",
            "DELETE_ERROR": "Fejl under sletning af portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Rediger portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Grundlæggende oplysninger"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Tilpasning af portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorier"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Landestandarder"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorier i",
          "NEW_CATEGORY": "Ny kategori",
          "TABLE": {
            "NAME": "Navn",
            "DESCRIPTION": "Beskrivelse",
            "LOCALE": "Landestandard",
            "ARTICLE_COUNT": "Antal artikler",
            "ACTION_BUTTON": {
              "EDIT": "Rediger kategori",
              "DELETE": "Slet kategori"
            },
            "EMPTY_TEXT": "Ingen kategorier fundet"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Opdater grundlæggende indstillinger"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Information om hjælpecenter",
            "BODY": "Grundlæggende oplysninger om portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Tilpasning af hjælpecenter",
            "BODY": "Tilpas portal"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "Du er klar!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Tilbage",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Opret portal",
            "TITLE": "Information om hjælpecenter",
            "CREATE_BASIC_SETTING_BUTTON": "Opret grundlæggende portalindstillinger"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Tilpasning af portal",
            "TITLE": "Tilpasning af hjælpecenter",
            "UPDATE_PORTAL_BUTTON": "Opdater portalindstillinger"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Alt er sat op!",
            "MESSAGE": "Du kan nu se den oprettede portal på siden med alle portaler.",
            "FINISH": "Gå til siden med alle portaler"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Upload logo",
          "HELP_TEXT": "Dette logo vil blive vist på portalens header.",
          "IMAGE_UPLOAD_SUCCESS": "Logo uploadet",
          "IMAGE_UPLOAD_ERROR": "Logo blev slettet",
          "IMAGE_DELETE_ERROR": "Fejl under sletning af logo"
        },
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Portal navn",
          "HELP_TEXT": "Navnet vil blive brugt internt i den offentlige portal.",
          "ERROR": "Navn er påkrævet"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-slug til webadresser",
          "ERROR": "Slug er påkrævet"
        },
        "DOMAIN": {
          "LABEL": "Tilpasset Domæne",
          "PLACEHOLDER": "Portal brugerdefineret domæne",
          "HELP_TEXT": "Tilføj kun hvis du vil bruge et brugerdefineret domæne til dine portaler. Eks.: {exampleURL}",
          "ERROR": "Indtast et gyldigt domæne URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link Til Hjemmeside",
          "PLACEHOLDER": "Link til portalens hjemmeside",
          "HELP_TEXT": "Linket, der bruges til at vende tilbage fra portalen til hjemmesiden. Eks.: {exampleURL}",
          "ERROR": "Indtast en gyldig URL til startsiden"
        },
        "THEME_COLOR": {
          "LABEL": "Portal tema farve",
          "HELP_TEXT": "Denne farve vil blive vist som temafarven for portalen."
        },
        "PAGE_TITLE": {
          "LABEL": "Side Titel",
          "PLACEHOLDER": "Portal side titel",
          "HELP_TEXT": "Sidetitlen vil blive brugt i den offentlige portal.",
          "ERROR": "Sidetitel er påkrævet"
        },
        "HEADER_TEXT": {
          "LABEL": "Header Tekst",
          "PLACEHOLDER": "Portal header tekst",
          "HELP_TEXT": "Portal header tekst vil blive brugt i den offentlige portal.",
          "ERROR": "Portal header tekst er påkrævet"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal oprettet.",
          "ERROR_MESSAGE_FOR_BASIC": "Portalen kunne ikke oprettes. Prøv igen.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal opdateret.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portalen kunne ikke opdateres. Prøv igen."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Tilføj en ny landestandard",
        "SUB_TITLE": "Dette tilføjer en ny landestandard til din tilgængelige oversættelsesliste.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Landestandard",
          "PLACEHOLDER": "Vælg en landestandard",
          "ERROR": "Landestandard er påkrævet"
        },
        "BUTTONS": {
          "CREATE": "Opret landestandard",
          "CANCEL": "Annuller"
        },
        "API": {
          "SUCCESS_MESSAGE": "Landestandard tilføjet",
          "ERROR_MESSAGE": "Kan ikke tilføje locale. Prøv igen."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Standard landestandard opdateret",
          "ERROR_MESSAGE": "Kan ikke opdatere standard locale. Prøv igen."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Landestandard fjernet fra portal",
          "ERROR_MESSAGE": "Kan ikke fjerne landestandard fra portalen. Prøv igen."
        }
      }
    },
    "TABLE": {
      "404": "Ingen artikler matcher din søgning 🔍",
      "LOADING_MESSAGE": "Indlæser artikler...",
      "NO_ARTICLES": "Der er ingen tilgængelige artikler",
      "HEADERS": {
        "TITLE": "Titel",
        "CATEGORY": "Kategori",
        "READ_COUNT": "Visninger",
        "STATUS": "Status",
        "LAST_EDITED": "Sidst redigeret"
      },
      "COLUMNS": {
        "BY": "af",
        "AUTHOR_NOT_AVAILABLE": "Forfatteren er ikke tilgængelig"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Indlæser artikel...",
      "TITLE_PLACEHOLDER": "Artikel titel vises her",
      "CONTENT_PLACEHOLDER": "Skriv din artikel her",
      "API": {
        "ERROR": "Fejl under lagring af artikel"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Fejl under publicering af artikel",
        "SUCCESS": "Artiklen er publiceret"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Fejl under arkivering af artikel",
        "SUCCESS": "Artikel arkiveret"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Fejl under ændring af artikel til Draft",
        "SUCCESS": "Artiklen blev ændret til Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Bekræft Sletning",
          "MESSAGE": "Er du sikker på at du vil slette artiklen?",
          "YES": "Ja, Slet",
          "NO": "Nej, behold det"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikel slettet",
        "ERROR_MESSAGE": "Fejl under sletning af artikel"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Tilføj venligst artiklens overskrift og indhold, før du kan opdatere indstillingerne"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Søg efter artikler"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Opret en kategori",
        "SUB_TITLE": "Kategorien vil blive brugt i den offentlige portal til at kategorisere artikler.",
        "PORTAL": "Portal",
        "LOCALE": "Landestandard",
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Kategori navn",
          "HELP_TEXT": "Kategorinavn og ikon vil blive brugt i den offentlige portal til at kategorisere artikler.",
          "ERROR": "Navn er påkrævet"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug til webadresser",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug er påkrævet"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Giv en kort beskrivelse af kategorien.",
          "ERROR": "Beskrivelse er påkrævet"
        },
        "BUTTONS": {
          "CREATE": "Opret kategori",
          "CANCEL": "Annuller"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategori oprettet",
          "ERROR_MESSAGE": "Kan ikke oprette kategori"
        }
      },
      "EDIT": {
        "TITLE": "Rediger en kategori",
        "SUB_TITLE": "Redigering af en kategori vil opdatere kategorien i den offentlige portal.",
        "PORTAL": "Portal",
        "LOCALE": "Landestandard",
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Kategori navn",
          "HELP_TEXT": "Kategorinavn og ikon vil blive brugt i den offentlige portal til at kategorisere artikler.",
          "ERROR": "Navn er påkrævet"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug til webadresser",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug er påkrævet"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Giv en kort beskrivelse af kategorien.",
          "ERROR": "Beskrivelse er påkrævet"
        },
        "BUTTONS": {
          "CREATE": "Opdater kategori",
          "CANCEL": "Annuller"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategori opdateret",
          "ERROR_MESSAGE": "Kan ikke opdatere kategori"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategori slettet",
          "ERROR_MESSAGE": "Kan ikke slette kategori"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Søg efter artikler",
      "PLACEHOLDER": "Søg efter artikler",
      "NO_RESULT": "Ingen artikler fundet",
      "SEARCHING": "Søger...",
      "SEARCH_BUTTON": "Søg",
      "INSERT_ARTICLE": "Indsæt link",
      "IFRAME_ERROR": "URL er tom eller ugyldig. Kan ikke vise indholdet.",
      "OPEN_ARTICLE_SEARCH": "Indsæt artikel fra Hjælpecenter",
      "SUCCESS_ARTICLE_INSERTED": "Artikel indsat",
      "PREVIEW_LINK": "Forhåndsvis artikel",
      "CANCEL": "Luk",
      "BACK": "Tilbage",
      "BACK_RESULTS": "Tilbage til resultater"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Hjælpecenter",
      "DESCRIPTION": "Opret brugervenlige selvbetjeningsportaler. Hjælp dine brugere med at få adgang til artiklerne og få support 24/7. Opgrader dit abonnement for at aktivere denne funktion.",
      "SELF_HOSTED_DESCRIPTION": "Opret brugervenlige selvbetjeningsportaler. Hjælp dine brugere med at få adgang til artiklerne og få support 24/7. Kontakt din administrator for at aktivere denne funktion.",
      "BUTTON": {
        "LEARN_MORE": "Lær mere",
        "UPGRADE": "Opgrader"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Flere portaler",
          "DESCRIPTION": "Opret flere selvbetjeningscentre for forskellige produkter ved hjælp af samme konto."
        },
        "LOCALES": {
          "TITLE": "Fuld understøttelse af flere sprog på samme tid",
          "DESCRIPTION": "Lokaliser portalen på dit sprog. Vi understøtter alle landestandarder og tillader oversættelser for alle artikler."
        },
        "SEO": {
          "TITLE": "SEO venligt design",
          "DESCRIPTION": "Tilpas dine metatags for at forbedre din synlighed på søgemaskiner med vores SEO-venlige sider."
        },
        "API": {
          "TITLE": "Fuld API-understøttelse",
          "DESCRIPTION": "Brug portalen som et headless CMS med tredjeparts frontend-frameworks via vores API'er."
        }
      }
    },
    "LOADING": "Indlæser...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visning | {count} visninger",
          "DROPDOWN_MENU": {
            "PUBLISH": "Udgiv",
            "DRAFT": "Draft",
            "ARCHIVE": "Arkivér",
            "DELETE": "Slet"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publiceret",
            "ARCHIVED": "Arkiveret"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Ikke kategoriseret"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Alle artikler",
          "MINE": "Mine",
          "DRAFT": "Draft",
          "PUBLISHED": "Publiceret",
          "ARCHIVED": "Arkiveret"
        },
        "CATEGORY": {
          "ALL": "Alle kategorier"
        },
        "LOCALE": {
          "ALL": "Alle landestandarder"
        },
        "NEW_ARTICLE": "Ny artikel"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Skriv en artikel",
          "SUBTITLE": "Skriv en indholdsrig artikel, lad os komme i gang!",
          "BUTTON_LABEL": "Ny artikel"
        },
        "MINE": {
          "TITLE": "Du har ikke skrevet nogen artikler her endnu",
          "SUBTITLE": "Alle artikler skrevet af dig vises her for hurtig adgang."
        },
        "DRAFT": {
          "TITLE": "Der er ingen artikler i Draft",
          "SUBTITLE": "Draft-artikler vises her"
        },
        "PUBLISHED": {
          "TITLE": "Der er ingen publicerede artikler",
          "SUBTITLE": "Publicerede artikler vises her"
        },
        "ARCHIVED": {
          "TITLE": "Der er ingen artikler i arkivet",
          "SUBTITLE": "Arkiverede artikler vises ikke på portalen. Du kan bruge det til at markere forældede eller udgåede sider"
        },
        "CATEGORY": {
          "TITLE": "Der er ingen artikler i denne kategori",
          "SUBTITLE": "Artikler i denne kategori vises her"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Ny kategori",
        "EDIT_CATEGORY": "Rediger kategori",
        "CATEGORIES_COUNT": "{n} kategori | {n} kategorier",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorier ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artikler) | {categoryName} ({categoryCount} artikel)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Ingen kategorier fundet",
        "SUBTITLE": "Kategorier vises her. Du kan tilføje en kategori ved at klikke på knappen 'Ny kategori'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artikler",
        "EXPAND": "Vis underkategorier",
        "COLLAPSE": "Skjul underkategorier",
        "MENU": {
          "NEW_ARTICLE": "Ny artikel",
          "ADD_SUBCATEGORY": "Tilføj underkategori",
          "EDIT": "Rediger",
          "DELETE": "Slet"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori oprettet",
            "ERROR_MESSAGE": "Kan ikke oprette kategori"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori opdateret",
            "ERROR_MESSAGE": "Kan ikke opdatere kategori"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori slettet",
            "ERROR_MESSAGE": "Kan ikke slette kategori"
          },
          "CONFIRM": {
            "TITLE": "Slet kategori",
            "DESCRIPTION": "Er du sikker på, at du vil slette denne kategori? Dens artikler bliver ukategoriserede.",
            "DESCRIPTION_WITH_CHILDREN": "Er du sikker på, at du vil slette denne kategori? Dens artikler bliver ukategoriserede, og dens {count} underkategori flyttes til øverste niveau. | Er du sikker på, at du vil slette denne kategori? Dens artikler bliver ukategoriserede, og dens {count} underkategorier flyttes til øverste niveau.",
            "CONFIRM": "Slet"
          }
        },
        "HEADER": {
          "CREATE": "Opret kategori",
          "EDIT": "Rediger kategori",
          "DESCRIPTION": "Redigering af en kategori vil opdatere kategorien i den offentlige portal.",
          "PORTAL": "Portal",
          "LOCALE": "Landestandard"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Navn",
            "PLACEHOLDER": "Kategori navn",
            "ERROR": "Navn er påkrævet"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategori-slug til webadresser",
            "ERROR": "Slug er påkrævet",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Beskrivelse",
            "PLACEHOLDER": "Giv en kort beskrivelse af kategorien.",
            "ERROR": "Beskrivelse er påkrævet"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Overordnet kategori",
            "PLACEHOLDER": "Vælg en overordnet kategori",
            "NONE": "Ingen (øverste niveau)"
          }
        },
        "BUTTONS": {
          "CREATE": "Opret",
          "EDIT": "Opdater",
          "CANCEL": "Annuller"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Ingen landestandarder tilgængelige | {n} landestandard | {n} landestandarder",
      "NEW_LOCALE_BUTTON_TEXT": "Ny landestandard",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artikler",
        "CATEGORIES_COUNT": "{count} kategori | {count} kategorier",
        "DEFAULT": "Standard",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Gør til standard",
          "DELETE": "Slet"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Tilføj en ny landestandard",
        "DESCRIPTION": "Vælg det sprog, denne artikel skal skrives på. Dette bliver tilføjet til din liste over oversættelser, og du kan tilføje flere senere.",
        "COMBOBOX": {
          "PLACEHOLDER": "Vælg landestandard..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Landestandard tilføjet",
          "ERROR_MESSAGE": "Kan ikke tilføje locale. Prøv igen."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Gemmer...",
          "SAVED": "Gemt"
        },
        "PREVIEW": "Eksempelvisning",
        "PUBLISH": "Udgiv",
        "DRAFT": "Draft",
        "ARCHIVE": "Arkivér",
        "BACK_TO_ARTICLES": "Tilbage til artikler"
      },
      "DRAFT": {
        "PENDING_LABEL": "Ikke-publicerede ændringer",
        "PROMOTE": "Publicér ændringer",
        "DISCARD": "Kassér ændringer",
        "PROMOTE_SUCCESS": "Draft-ændringerne blev publiceret til den aktive artikel",
        "PROMOTE_ERROR": "Kunne ikke publicere Draft-ændringerne",
        "DISCARD_SUCCESS": "Draft-ændringerne blev kasseret",
        "DISCARD_ERROR": "Kunne ikke kassere Draft-ændringerne"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versionshistorik",
        "TITLE": "Versionshistorik",
        "BACK": "Tilbage til artikel",
        "LOADING": "Indlæser versioner...",
        "EMPTY": "Ingen versioner endnu. Ændringer til denne artikel vises her.",
        "EMPTY_CONTENT": "Denne version har intet indhold.",
        "CURRENT_BADGE": "Nuværende",
        "RESTORED_BADGE": "Gendannet",
        "AUTOMATED_USER": "Automatisk opdatering",
        "RESTORE": "Gendan denne version",
        "RESTORE_DIALOG": {
          "TITLE": "Gendan denne version?",
          "DESCRIPTION": "Artiklen vender tilbage til ordlyden i denne version. Intet går tabt — den nuværende tekst forbliver i historikken, og en publiceret artikel bliver ved med at vise den aktive version, indtil du publicerer ændringen.",
          "CONFIRM": "Gendan"
        },
        "RESTORE_SUCCESS": "Version gendannet",
        "RESTORE_ERROR": "Kunne ikke gendanne denne version",
        "FETCH_ERROR": "Kunne ikke indlæse versionshistorikken"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Flere egenskaber",
        "TRANSLATE": "Oversæt",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Ikke kategoriseret",
        "EDITOR_PLACEHOLDER": "Skriv noget...",
        "HTML_EMBED": {
          "TITLE": "Indsæt brugerdefineret HTML",
          "DESCRIPTION": "Indsæt rå HTML såsom en iframe, et embed eller et widget-uddrag. Det vises, som det er, i den udgivne artikel.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Indsæt"
        },
        "PRIMARY_CATEGORY": "Primær kategori"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikelegenskaber",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta beskrivelse",
        "META_DESCRIPTION_PLACEHOLDER": "Tilføj meta beskrivelse",
        "META_TITLE": "Meta titel",
        "META_TITLE_PLACEHOLDER": "Tilføj meta titel",
        "META_TAGS": "Metatags",
        "META_TAGS_PLACEHOLDER": "Tilføj meta tags",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Sprogvarianter",
        "LANGUAGE_MUTATIONS_EMPTY": "Ingen tilknyttede artikler endnu",
        "ADD_MUTATION": "Tilføj",
        "REMOVE_MUTATION": "Fjern"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Tilknyt sprogvarianter",
        "SEARCH_PLACEHOLDER": "Søg artikler efter titel",
        "EMPTY": "Ingen matchende artikler",
        "CANCEL": "Annuller",
        "ADD_SELECTED": "Tilføj valgte",
        "SUCCESS": "Varianter opdateret",
        "ERROR": "Kunne ikke opdatere varianter"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Oversæt artikel",
        "DESCRIPTION": "Vælg de sprog, du vil oversætte denne artikel til. Sprog, der allerede er oversat, bliver gen-oversat til en Draft til gennemgang.",
        "EMPTY": "Der er ingen andre sprog tilgængelige",
        "CONNECTED_BADGE": "Oversat",
        "CANCEL": "Annuller",
        "TRANSLATE": "Oversæt",
        "SUCCESS": "Oversættelsen starter snart. De oversatte artikler vil snart blive vist som sprogvarianter.",
        "ERROR": "Kunne ikke starte oversættelsen"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Fejl under lagring af artikel"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Ny portal",
      "PORTALS": "Portaler",
      "CREATE_PORTAL": "Opret og administrer flere portaler",
      "ARTICLES": "artikler",
      "DOMAIN": "domæne",
      "PORTAL_NAME": "Portal navn"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Opret ny portal",
      "DESCRIPTION": "Giv din portal et navn, og opret en brugervenlig URL-slug. Du kan ændre begge dele senere i indstillingerne.",
      "CONFIRM_BUTTON_LABEL": "Opret",
      "NAME": {
        "LABEL": "Navn",
        "PLACEHOLDER": "Brugervejledning",
        "MESSAGE": "Vælg et navn til din portal.",
        "ERROR": "Navn er påkrævet"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug er påkrævet",
        "FORMAT_ERROR": "Brug kun bogstaver, tal og bindestreger, for eksempel: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Kunne ikke uploade billede! Prøv igen",
          "IMAGE_UPLOAD_SUCCESS": "Billede tilføjet. Klik på Gem ændringer for at gemme logoet",
          "IMAGE_DELETE_SUCCESS": "Logo blev slettet",
          "IMAGE_DELETE_ERROR": "Kan ikke slette logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Billedets størrelse skal være mindre end {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Portal navn",
          "ERROR": "Navn er påkrævet"
        },
        "HEADER_TEXT": {
          "LABEL": "Header tekst",
          "PLACEHOLDER": "Portal header tekst"
        },
        "PAGE_TITLE": {
          "LABEL": "Sidetitel",
          "PLACEHOLDER": "Portal side titel"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link til hjemmeside",
          "PLACEHOLDER": "Link til portalens hjemmeside",
          "ERROR": "Ugyldig URL. Linket til hjemmesiden skal starte med 'http://' eller 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat-widget",
          "PLACEHOLDER": "Vælg live chat-widget",
          "HELP_TEXT": "Vælg en live chat-widget, der skal vises i dit hjælpecenter"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Offentligt tilgængelig",
          "HELP_TEXT": "Gør portalen tilgængelig for alle med link.",
          "OPTIONS": {
            "PUBLIC": "Ja",
            "PRIVATE": "Nej"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Linkmål",
          "HELP_TEXT": "Vælg, om links i artikler åbnes i det aktuelle vindue eller i et nyt.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuelt vindue",
            "NEW_WINDOW": "Nyt vindue"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Standardbilledstørrelse",
          "HELP_TEXT": "Størrelsen, der anvendes på alle billeder, du indsætter i en artikel. Vælg Original for at indsætte billeder i deres egen størrelse og vælge en størrelse pr. billede i stedet."
        },
        "BRAND_COLOR": {
          "LABEL": "Brandfarve"
        },
        "CUSTOM_HTML": {
          "LABEL": "Brugerdefineret HTML",
          "PLACEHOLDER": "<!-- Indsæt din analyse- eller sporingskode her -->",
          "HELP_TEXT": "Indsættes i starten af <body>-tagget på hver hjælpecenterside. Brug det til Google Analytics, Google Tag Manager eller anden sporingskode. Koden vises præcis som indtastet og bliver ikke valideret."
        },
        "SAVE_CHANGES": "Gem ændringer"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Tilpasset domæne",
          "LABEL": "Tilpasset domæne:",
          "DESCRIPTION": "Du kan hoste din portal på et tilpasset domæne. Hvis din hjemmeside for eksempel er yourdomain.com, og du vil have din portal tilgængelig på docs.yourdomain.com, skal du blot indtaste det i dette felt.",
          "PLACEHOLDER": "Portal brugerdefineret domæne",
          "EDIT_BUTTON": "Rediger tilpasset domæne",
          "ADD_BUTTON": "Tilføj tilpasset domæne",
          "DIALOG": {
            "ADD_HEADER": "Tilføj tilpasset domæne",
            "EDIT_HEADER": "Rediger tilpasset domæne",
            "ADD_CONFIRM_BUTTON_LABEL": "Tilføj domæne",
            "EDIT_CONFIRM_BUTTON_LABEL": "Opdater domæne",
            "LABEL": "Tilpasset domæne",
            "PLACEHOLDER": "Portal brugerdefineret domæne",
            "ERROR": "Tilpasset domæne er påkrævet"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-konfiguration",
            "DESCRIPTION": "Log ind på den konto, du har hos din DNS-udbyder, og tilføj CNAME-posten nedenfor for dit underdomæne.",
            "HELP_TEXT": "Når det er gjort, kan du kontakte vores support for at anmode om det automatisk genererede SSL-certifikat.",
            "CONFIRM_BUTTON_LABEL": "Forstået!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Slet {portalName}",
          "HEADER": "Slet portal",
          "DESCRIPTION": "Slet denne portal permanent. Denne handling kan ikke fortrydes",
          "DIALOG": {
            "HEADER": "Er du sikker på, at du vil slette {portalName}?",
            "DESCRIPTION": "Dette er en permanent handling, der ikke kan fortrydes.",
            "CONFIRM_BUTTON_LABEL": "Slet"
          }
        },
        "EDIT_CONFIGURATION": "Rediger konfiguration"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal oprettet",
          "ERROR_MESSAGE": "Kan ikke oprette portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal opdateret",
          "ERROR_MESSAGE": "Kan ikke opdatere portal"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Vedhæftede filer",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Tilføj fil",
      "DROP_HERE": "Træk og slip filer her",
      "COPY_LINK": "Kopiér link",
      "LINK_COPIED": "Link kopieret til udklipsholder",
      "COPY_FAILED": "Kunne ikke kopiere link",
      "DELETE": "Slet",
      "CANCEL": "Annuller",
      "QUEUED": "I kø",
      "UPLOADING": "Uploader",
      "UPLOAD_FAILED": "Kunne ikke uploade fil",
      "FILE_TOO_LARGE": "Filen overskrider grænsen på 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Oversættelsesordbog",
        "DESCRIPTION": "Termer, der defineres her, tilføjes til AI-oversættelsesprompten, så de altid oversættes på samme måde. Nøgletermen er skrevet på {locale}."
      },
      "NEW_TERM": "Ny term",
      "EMPTY_STATE": {
        "TITLE": "Der er endnu ingen termer i ordbogen",
        "SUBTITLE": "Tilføj en term og dens oversættelse for hvert sprog. Når en artikel oversættes, håndhæves disse termer, så dit produkts ordvalg forbliver konsistent."
      },
      "LIST": {
        "TERM": "Term",
        "TRANSLATIONS": "Oversættelser",
        "ACTIONS": "Handlinger"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Tilføj term",
          "EDIT": "Rediger term",
          "DESCRIPTION": "Termen nedenfor håndhæves under AI-oversættelse af dine hjælpecenterartikler.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primært sprog"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Term ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Term er påkrævet"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst/noter (valgfrit)",
            "PLACEHOLDER": "Hvornår og hvordan denne term bruges, for at hjælpe oversætteren med at undgå tvetydighed."
          },
          "TRANSLATIONS": "Oversættelser",
          "TRANSLATION_PLACEHOLDER": "Lad stå tomt, så AI'en oversætter frit",
          "AUTO_TRANSLATE": {
            "BUTTON": "Auto-oversæt alle",
            "CONFIRM": "Oversæt til {count} sprog med AI?",
            "CONFIRM_BUTTON": "Oversæt",
            "CANCEL": "Annuller",
            "SUCCESS": "Oversættelser genereret — gennemgå og gem",
            "ERROR": "Kunne ikke auto-oversætte, prøv igen"
          }
        },
        "BUTTONS": {
          "CREATE": "Tilføj term",
          "EDIT": "Gem",
          "CANCEL": "Annuller"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termen blev tilføjet",
            "ERROR_MESSAGE": "Kunne ikke tilføje termen. Prøv igen"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termen blev opdateret",
            "ERROR_MESSAGE": "Kunne ikke opdatere termen. Prøv igen"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Slet term",
          "DESCRIPTION": "Er du sikker på, at du vil slette denne term? Den vil ikke længere blive håndhævet under oversættelse.",
          "CONFIRM": "Slet"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termen blev slettet",
          "ERROR_MESSAGE": "Kunne ikke slette termen. Prøv igen"
        }
      }
    }
  }
}
